import React, { useState, useContext } from 'react';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../firebase';
import { UserContext } from '../../contexts/UserContext';
import { runTransaction,increment,doc, setDoc, collection, updateDoc, getDocs, query, where,getDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid'; // Assurez-vous d'avoir installé le package uuid
import Spinner from 'react-bootstrap/Spinner';
import { Carousel } from 'react-bootstrap';
import slide1 from './../../assets/images/slide1.jpg';
import slide from './../../assets/images/slide.png';
import iconPanier from './../../assets/images/Vector2.png';
import iconcalendar from './../../assets/images/Vector4.png';


const stripePromise = loadStripe('pk_live_51SD0XIGTwMXnayaqb5NC25UGLDmz7xsv190J9RuIUd0aoBgag5bMxDRLhYXUy3ZTvlBm4lSR9tjEKGmfq1ivZi1200Jo0jLi9W');
// const storedPanier = localStorage.getItem('panier');
// const parsedPanier = storedPanier ? JSON.parse(storedPanier) : [];

const CheckoutForm = ({ pickupTime }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isUpdating, setIsUpdating] = useState(false);
  const [cardError, setCardError] = useState('');
  const [showSuccesModal, setShowSuccesModal] = useState(false);
  const [clientInfo, setClientInfo] = useState({
    nom: '',
    prenom: '',
    email: '',
    tele: '',
    adresse: ''
  });
  const [promoCode, setPromoCode] = useState('');
  const [discount, setDiscount] = useState(0);
  const storedPanier = localStorage.getItem('panier');
const parsedPanier = storedPanier ? JSON.parse(storedPanier) : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setClientInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value
    }));
  };

  const handlePromoCodeChange = (e) => {
    setPromoCode(e.target.value);
  };

  const handleApplyPromoCode = async () => {
    try {
      const q = query(collection(db, 'promos'), where('promo_code', '==', promoCode));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const promoDoc = querySnapshot.docs[0];
        const promoData = promoDoc.data();
        const today = new Date();

        const validFrom = promoData.valid_from.toDate();
        const validTo = promoData.valid_to.toDate();

        if (promoData.statut && validFrom <= today && validTo >= today) {
          if (promoData.usage_count < promoData.usage_limit) {
            const discountAmount =
              promoData.promo_type === 'percentage'
                ? (calculateTotal() * promoData.promo_valeur) / 100
                : promoData.promo_valeur;

            setDiscount(discountAmount);

            await updateDoc(promoDoc.ref, {
              usage_count: increment(1)
            });

            alert('Code promo appliqué avec succès!');
          } else {
            alert('Limite d\'utilisation du code promo atteinte.');
          }
        } else {
          alert('Code promo invalide ou expiré.');
        }
      } else {
        alert('Code promo non trouvé.');
      }
    } catch (error) {
      console.error('Erreur lors de l\'application du code promo:', error);
      alert('Erreur lors de l\'application du code promo. Vérifiez la connexion à Firestore.');
    }
  };

const calculateTotal = () => {
  const total = parsedPanier.reduce((total, plat) => {
    // Prix du plat principal
    let platTotal = parseFloat(plat.prix) * plat.quantite;

    // Prix des addons (modules)
    if (plat.addons && plat.addons.length > 0) {
      plat.addons.forEach((addon) => {
        if (addon.modules && addon.modules.length > 0) {
          addon.modules.forEach((module) => {
            platTotal += parseFloat(module.prix) * plat.quantite;
          });
        }
      });
    }

    return total + platTotal;
  }, 0);

  return (total - discount).toFixed(2);
};


  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsUpdating(true);

    if (!stripe || !elements) return;

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
      billing_details: {
        name: `${clientInfo.prenom} ${clientInfo.nom}`,
        email: clientInfo.email,
        phone: clientInfo.tele,
        address: {
          line1: clientInfo.adresse
        }
      }
    });

    if (error) {
      setCardError(error.message);
      setIsUpdating(false);
      return;
    }

    setCardError('');

    try {
      const response = await fetch('https://api-qdhov6jyia-uc.a.run.app/api/payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          paymentMethodId: paymentMethod.id,
          amount: Math.round(calculateTotal() * 100)
        })
      });

      if (!response.ok) throw new Error(`Erreur lors de la requête : ${response.status}`);

      const data = await response.json();

      if (data.success) {
        const date_commande = new Date().toLocaleString('fr-FR');
        const date_service = `${new Date().toLocaleDateString('fr-FR')} ${pickupTime}`;

        const newOrderId = await runTransaction(db, async (transaction) => {
          const counterRef = doc(db, 'metadata', 'commandeCounter');
          const counterSnapshot = await transaction.get(counterRef);
          const currentCounter = counterSnapshot.data().currentValue;
          const newCounter = currentCounter + 1;
          transaction.update(counterRef, { currentValue: newCounter });
          return newCounter;
        });

        await setDoc(doc(db, 'commande', newOrderId.toString()), {
          id: newOrderId.toString(),
          ...clientInfo,
          plats: parsedPanier,
          date_commande,
          date_service,
          montant: calculateTotal(),
          statut_commande: 'En cours',
          statut_paiement: 'Payé',
          paymentIntentId: data.clientSecret.split('_secret')[0],
          promo: promoCode ? { code: promoCode, discount } : null
        });

        
  // // ✅ Appel webhook Zapier
  //         await fetch("https://api-qdhov6jyia-uc.a.run.app/api/sendZapier", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({
  //             orderId: newOrderId,
  //             client: clientInfo.nom,
  //             montant: calculateTotal(),
  //             date_commande,
  //             date_service,
  //             plats: parsedPanier
  //           })
  //         });

        localStorage.removeItem('panier');
        setShowSuccesModal(true);
      }
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
    } finally {
      setIsUpdating(false);
    }
  };

    
    


    return (
        <div>
        <form onSubmit={handleSubmit}>
            {/* Client Information Fields */}
            <div className="row mb-4">
                <div className="col-6">
                    <div className="form-group">
                        <input type="text" id="nom" name="nom" className="form-control form-stl" placeholder="Nom" value={clientInfo.nom} onChange={handleChange}  required />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <input type="text" id="prenom" placeholder="Prénom" name="prenom" className="form-control form-stl" value={clientInfo.prenom} onChange={handleChange} required />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <input type="email" id="email" placeholder="Email" name="email" className="form-control form-stl" value={clientInfo.email} onChange={handleChange} required />
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <input type="tel" id="tele" placeholder="Téléphone" name="tele" className="form-control form-stl" value={clientInfo.tele} onChange={handleChange} required />
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <textarea id="adresse" placeholder="Adresse" name="adresse" className="form-control form-stl" value={clientInfo.adresse} onChange={handleChange} required />
                    </div>
                </div>
                {/* <div className="col-12">
                    <div className="form-check mt-2">
                        <input
                            type="checkbox"
                            id="emailConsent"
                            className="form-check-input"
                            checked={clientInfo.emailConsent}
                            onChange={(e) =>
                                setClientInfo({ ...clientInfo, emailConsent: e.target.checked })
                            }
                        />
                        <label className="form-check-label" htmlFor="emailConsent">
                           Je souhaite recevoir par e-mail les actualités, offres et nouveautés du restaurant Istanbul Narbonne.
                        </label>
                    </div>
                </div> */}
                <div className="col-12 mt-3 mb-3">
                    {/* Payment Information Fields */}
                    <div className="form-group">
                        <label htmlFor="card" className='small-tl mb-3'>Carte de Crédit</label>
                        <CardElement id="card" />
                        {cardError && <p style={{ color: 'red', marginTop: '10px' }}>{cardError}</p>}
                    </div>
                </div>
                
                <div className="col-12 mt-3 mb-3">
                    <div className="form-group promo-from">
                        <label htmlFor="promoCode">Code Promo</label>
                        <div className="input-group">
                            <input
                                type="text"
                                id="promoCode"
                                className="form-control"
                                value={promoCode}
                                onChange={handlePromoCodeChange}
                            />
                            <div className="input-group-append">
                                <button
                                    type="button"
                                    className="btn btn-promo"
                                    onClick={handleApplyPromoCode}
                                >
                                    Appliquer
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* <p className='msg-promo mt-3'>Code promo <strong>10%</strong>: istanbul10 (*valable pour les <strong>100</strong> premières commandes)</p> */}
                </div>
                <div className="col-12 mb-3">
                    <button  type="submit" className="btn btn-red submit-btn w-100 mt-3" disabled={isUpdating || !stripe} >
                   
                        {isUpdating ? <span>Payer {calculateTotal()}€ <span className="spinner-border spinner-border-sm"></span></span> : <span>Payer {calculateTotal()}€</span>}
                    </button>
                </div>
            </div>
            
        </form>
            <Modal
            show={showSuccesModal}
            onHide={() => navigate('/boutique')}
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title>Confirmation de commande</Modal.Title>
            </Modal.Header>
           <Modal.Body style={{ textAlign: 'center' }}>
            <p>Merci ! Votre commande est enregistrée.</p>
            <p>Le récapitulatif vous a été envoyé par e-mail.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                variant="success"
                className="btn-red2"
                onClick={() => navigate('/boutique')}
                >
                Retour à la boutique
                </Button>
            </Modal.Footer>
            </Modal>

        </div>
        
    );
};

const Checkout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { panier, pickupTime } = location.state || { panier: [], pickupTime: '' };
    const { client } = useContext(UserContext);
    // const [existingCustomerId, setExistingCustomerId] = useState(null);
const storedPanier = localStorage.getItem('panier');
const parsedPanier = storedPanier ? JSON.parse(storedPanier) : [];
    
    const handleSaveCart = async () => {
       
    
        if (!client || client.role !== 'eEmUFguwSDauXnztOHs1') {
            console.error('User is not logged in or user context is undefined.');
            navigate('/login');
            return;
        } else {
            
            try {
                // Générer un ID unique pour le panier
                const panierId = uuidv4();
    
                // Créer le document dans la collection 'panier' avec l'ID généré
                await setDoc(doc(db, 'panier', panierId), {
                    id: panierId,
                    user: client.id,
                    plat: parsedPanier.map(item => ({
                        id: item.id,
                        quantite: item.quantite
                    })),
                    date_saved: new Date().toLocaleString()
                });
    
                alert('Panier enregistré avec succès avec l\'ID : ' + panierId);
            } catch (error) {
                console.error('Erreur lors de l\'enregistrement du panier:', error);
            }
        }
    };
    
    

    const calculateTotal = () => {
  return parsedPanier
    .reduce((total, plat) => {
      const prixPlat = parseFloat(plat.prix) || 0;

      // Somme des prix des addons sélectionnés
      const prixAddons = plat.addons
        ? plat.addons.reduce((sum, addon) => {
            return (
              sum +
              addon.modules.reduce(
                (modSum, module) => modSum + (parseFloat(module.prix) || 0),
                0
              )
            );
          }, 0)
        : 0;

      // Prix total de ce plat = (plat + addons) * quantité
      return total + (prixPlat + prixAddons) * plat.quantite;
    }, 0)
    .toFixed(2);
};


    return (

        <div className="mt-5">
           <div class="section-hero">
                     <h2 class="titre-hero">Commande à emporter</h2>
                </div>
            <div className="content mrg-pg2">
                <div className="row">
                
                    <div className="col-md-8">

                  <div className="row">
                          <div className="col-md-9 pr-4 desktop-hd">
                              <Carousel className="custom-carousel">
                                  
                                  <Carousel.Item>
                                      <img
                                          className="d-block w-100 img-couv"
                                      src={slide}
                                          alt=""
                                      />
                                  </Carousel.Item>
                  
                                 
                              </Carousel>
                          </div>
                          <div className="col-md-3 flexX">
                                <Link className="btn-acc btn-panier d-block w-100 mb-3" to="/boutique">
                                    <img
                                        className="d-block icon-btn "
                                        src={iconPanier}
                                        alt=""
                                    />
                                    <span>Voir le menu</span>
                                </Link>
                                <Link className="btn-acc btn-cldr d-block w-100" to="https://chezpapy-pizza-narbonne.com/reservation/">
                                    <img
                                        className="d-block icon-btn"
                                        src={iconcalendar}
                                        alt=""
                                    />
                                    <span>Réserver une table</span>
                                </Link>
                          </div>
                  </div>
                  <div className="col-md-11 marg-panier ">

                    <h4 className='tl-pay'>Adresse de récupération</h4>
                     <p className='text-check'>52, Boulevard Anatole France, Narbonne</p>
                    <div className="card-map mt-5 mb-4 pb-4 ">
                       <iframe className="cont-map mb-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2909.0936494376674!2d2.992087700000001!3d43.186545800000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b1ad1550d68b35%3A0x55cc378138e6ea12!2sCHEZ%20PAPY!5e0!3m2!1sfr!2sma!4v1759928431679!5m2!1sfr!2sma"  loading="lazy" ></iframe>
                      
                    </div>

                    <h4 className='tl-pay mb-5'>Informations de paiement</h4>
                        <Elements stripe={stripePromise}>
                            <CheckoutForm panier={panier} pickupTime={pickupTime} />
                        </Elements>
                    </div>
                    <div className="col-md-1"></div>
                    </div>
                    
                    <div className="col-md-4 ">
                                <div className="bg-cart bg-cart2 rounded">
                                <h5 className='tl-cart'>Récapitulatif de commande</h5>

                                 <ul className="list-group mt-4">
                            {parsedPanier.map((item) => (
                               <div className="card-item-cart">
                                <li key={item.id} className=" d-flex justify-content-between">
                                    <div className='cart-item'>  
                                        <span className='qt-cart mr-2 '>{item.quantite} x</span> 
                                        <span className='mr-5'>{item.nom}</span>
                                    </div>
                                      <div className='cart-item'>  
                                        <span className='pr-cart'>{item.prix}€ </span>
                                    </div>
                                </li>
                                 {/* Afficher les addons */}
                                    {item.addons && item.addons.length > 0 && (
                                    <div className='item-addons'>
                                        {item.addons.map((addon) =>
                                        addon.modules.map((module, idx) => (
                                            <div key={idx} className='addon-line'>
                                            + {module.nom} ({module.prix}€)
                                            </div>
                                        ))
                                        )}
                                    </div>
                                    )}
                                </div>
                            ))}
                            
                            </ul> 
                                <p className="d-flex justify-content-between sous-total">
                            <span>Sous-Total</span>
                            <span className="red-color">{calculateTotal()} €</span>
                          </p>
                          
                          <p className="d-flex justify-content-between total">
                            <span>Total</span>
                            <span className="red-color">{calculateTotal()} €</span>
                          </p>
                                
                                
                                </div>
                                
                    </div>

                   
                </div>
            </div>
   

        </div>

    );
};

export default Checkout;
